import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// flex 布局库
import 'flex.css'
import 'font-awesome/css/font-awesome.min.css'
import Element from 'element-ui'
import store from '@/store'

// 组件
import '@/components'
import permission from '@/mixins/permission'

// 功能插件
import VXETable from '@/plugin/vxetable'
import pluginApi from '@/plugin/api'
import pluginPermission from '@/plugin/permission'
import pluginLocales from '@/plugin/locales'
import pluginPaste from '@/plugin/paste'
import pluginVEcharts from '@/plugin/vecharts'
import pluginVXETable from '@/plugin/vxetable'
import pluginSwiper from '@/plugin/swiper'
import pluginElDialogdrag from '@/plugin/el-dialog-drag'
import elInputNumberDefault0 from '@/plugin/el-inputnumber-default0'

export default {
  // eslint-disable-next-line no-unused-vars
  async install(Vue, options) {
    // 设置为 false 以阻止 vue 在启动时生成生产提示
    // https://cn.vuejs.org/v2/api/#productionTip
    Vue.config.productionTip = false
    // 当前环境
    Vue.prototype.$env = process.env.NODE_ENV
    // 当前的 baseUrl
    Vue.prototype.$baseUrl = process.env.BASE_URL
    // 当前版本
    Vue.prototype.$version = process.env.VUE_APP_VERSION
    // 构建时间
    Vue.prototype.$buildTime = process.env.VUE_APP_BUILD_TIME

    let system = store.state.admin.system
    // 系统配置
    Vue.prototype.$system = system
    // 拼接阿里云oss 文件地址
    Vue.prototype.$osscdn = (code) => {
      if (!code) return ''
      if (code.startsWith('http') || code.startsWith('blob:')) {
        return code
      }
      return system.oss.domain + code
    }

    // 非父子组件通讯
    Vue.prototype.$eventBus = new Vue()

    /**
     * 拼接完整URL路径
     * @param {*} url
     * @param {*} options
     * @returns
     */
    Vue.prototype.$joinURL = (
      url,
      { joinOrigin = true, joinBasePath = true } = {}
    ) => {
      if (!url) return ''
      if (url.startsWith('http') || url.startsWith('blob:')) {
        return url
      }
      const urls = [
        joinOrigin ? location.origin : null,
        joinBasePath ? system.oss.domain.replace(/(^\/)|(\/$)/g, '') : null,
        url.replace(/(^\/)|(\/$)/g, ''),
      ].filter(Boolean)
      return urls.join('/')
    }

    Vue.mixin(permission)
    Vue.use(BootstrapVue)
    Vue.use(IconsPlugin)
    // Vue.use(Menu);
    // Vue.use(Submenu);
    // Vue.use(MenuItem);
    // Vue.use(MenuItemGroup);
    // Vue.use(Loading);
    // Vue.use(Upload);
    Vue.use(Element, { zIndex: 1000 })

    // 插件
    Vue.use(VXETable)
    Vue.use(pluginApi)
    Vue.use(pluginPermission)
    Vue.use(pluginLocales)
    Vue.use(pluginPaste)
    Vue.use(pluginVEcharts)
    Vue.use(pluginVXETable)
    Vue.use(pluginSwiper)
    Vue.use(pluginElDialogdrag)
    Vue.use(elInputNumberDefault0)

    // Vue.prototype.$loading = Loading.service;
    // Vue.prototype.$message = Message;
  },
}
